module.exports = __webpack_public_path__ + "img/stockWarn.99ea5a0f.png";